import { Pipe, PipeTransform } from "@angular/core";
import { capitalize } from "src/app/static-data/models/consts/static-data.utils";

@Pipe({
    name: 'incrementalErrorMessage'
})
export class IncrementalErrorMessagePipe implements PipeTransform {

    transform(errors: any, type: 'units' | 'amount'): any {
        const capitalizedUnit = capitalize(type);
        if (errors) {
            if (errors[`invalidIncrementalTradingAmount`]) {
                return `Incremental Trading Amount should be a multiple of Denomination`;
            }

            if (errors[`invalidIncrementalTrading${capitalizedUnit}Maximum`]) {
                return `Incremental Trading ${capitalizedUnit} should be less than Max Trading ${capitalizedUnit}`;
            }
        }
        return null;
    }

}